"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const Debounce_1 = require("../../../../Utility/Decorator/Debounce");
/**
 * When `enter` is pressed on an open dialog, the given button is `clicked`
 *
 * Debounce slightly to prevent multiple consecutive triggers
 */
class DefaultButtonHandler {
    constructor(button) {
        this.button = button;
    }
    getButton() {
        return this.button;
    }
    handleEvent(event) {
        event.stopImmediatePropagation();
        event.preventDefault();
        this.button.click();
    }
}
exports.default = DefaultButtonHandler;
__decorate([
    (0, Debounce_1.default)(300)
], DefaultButtonHandler.prototype, "handleEvent", null);
//# sourceMappingURL=DefaultButtonHandler.js.map